import { render, staticRenderFns } from "./SwBadge.vue?vue&type=template&id=e2fe04ba"
import script from "./SwBadge.vue?vue&type=script&lang=js"
export * from "./SwBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports